module.exports = __webpack_public_path__ + "static/media/24UHCHR9.f81b56ed.jpg";